import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const { isAuthenticated, login, loading } = useAuth();
  const [error, setError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  if (loading) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleGoogleSuccess = async (credentialResponse) => {
    setError('');
    setIsLoggingIn(true);
    try {
      await login(credentialResponse.credential);
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setIsLoggingIn(false);
    }
  };

  const handleGoogleError = () => {
    setError('Google sign-in was cancelled or failed. Please try again.');
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Booktime Logo" className="login-logo" />
          <h1>Booktime</h1>
          <p>Sign in to continue</p>
        </div>

        {error && <div className="login-error">{error}</div>}

        <div className="login-button-wrapper">
          {isLoggingIn ? (
            <p className="login-loading">Signing in...</p>
          ) : (
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              theme="outline"
              size="large"
              width="300"
              text="signin_with"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
